"use strict";
var BoundCallbackObservable_1 = require('./BoundCallbackObservable');
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/~/rxjs/observable/bindCallback.js
// module id = ../../../../rxjs/observable/bindCallback.js
// module chunks = 3